/**
 * Tutorial guidato delle impostazioni Marketplace.
 *
 * Un preparativo solo: il riquadro del primo marketplace, che il passo dedicato apre
 * per mostrarne i campi. `stopMarketplaceTour` lo richiude a fine giro, e solo se ad
 * aprirlo e' stato il tutorial. Gli interruttori non si toccano: salvano subito, e
 * qui accendere qualcosa vuol dire far partire sincronizzazioni vere.
 */
const SCOPE = '[data-tour-scope="setting-marketplace"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro del primo marketplace, se non e' gia' aperto. */
function openFirst() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopMarketplaceTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createMarketplaceTourSteps() {
	return [
		{
			body: "Da qui il gestionale parla con i marketplace - Amazon, eBay, TikTok Shop - per mandare i prodotti e riportare dentro gli ordini. E' la pagina piu' delicata delle impostazioni: quello che si accende qui si vede sui canali di vendita veri.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I marketplace',
		},
		{
			body: "Una riga per marketplace, con il suo interruttore che salva subito. Acceso, il gestionale comincia a sincronizzare secondo quello che c'e' scritto dentro il riquadro: conviene aprirlo e leggerlo prima di accendere, non dopo.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Accendere un marketplace',
		},
		{
			body: "Il piu' a inizio riga apre la configurazione: le credenziali del venditore e, per alcuni canali, il pulsante che avvia l'autorizzazione dell'app - la finestra dove il marketplace chiede il permesso di lavorare per tuo conto.",
			before: stopMarketplaceTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire la configurazione',
		},
		{
			body: 'Dentro il riquadro gli interruttori delle sincronizzazioni sono la parte che pesa: anagrafica prodotti, giacenze, ordini. Le giacenze in particolare viaggiano nei due sensi - quello che succede qui si riflette su quanto il marketplace crede tu abbia in magazzino, e una sincronizzazione accesa per sbaglio si sente sulle vendite.',
			before: openFirst,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'Le sincronizzazioni',
		},
	];
}
